<script setup lang="ts">
import {nextTick, onUnmounted, ref, watch} from 'vue';
import {useLogger} from '@/ts/composables/pure/use-logger';
import {useCache} from '@/ts/composables/stateful/use-cache';

const cache = useCache('svg');
const props = defineProps<{
  name: string;
  innerClass?: string;
}>();

// check npm package ak-vite-plugins
// it will replace current Record at build time
const icons: Record<string, string> = {
  'admin-content.svg': new URL('@/assets/img/admin-content.svg', import.meta.url).href,
'admin-engagement.svg': new URL('@/assets/img/admin-engagement.svg', import.meta.url).href,
'admin-health.svg': new URL('@/assets/img/admin-health.svg', import.meta.url).href,
'admin-overview.svg': new URL('@/assets/img/admin-overview.svg', import.meta.url).href,
'admin-segments.svg': new URL('@/assets/img/admin-segments.svg', import.meta.url).href,
'alert-triangle.svg': new URL('@/assets/img/alert-triangle.svg', import.meta.url).href,
'arrow-left.svg': new URL('@/assets/img/arrow-left.svg', import.meta.url).href,
'arrow-narrow-right.svg': new URL('@/assets/img/arrow-narrow-right.svg', import.meta.url).href,
'arrow-narrow-up-right.svg': new URL('@/assets/img/arrow-narrow-up-right.svg', import.meta.url).href,
'arrow-right.svg': new URL('@/assets/img/arrow-right.svg', import.meta.url).href,
'balm-logo-for-dark-mode.svg': new URL('@/assets/img/balm-logo-for-dark-mode.svg', import.meta.url).href,
'balm-logo.svg': new URL('@/assets/img/balm-logo.svg', import.meta.url).href,
'balm-medical-logo-dark.svg': new URL('@/assets/img/balm-medical-logo-dark.svg', import.meta.url).href,
'balm-medical-logo.svg': new URL('@/assets/img/balm-medical-logo.svg', import.meta.url).href,
'balm-pictorial-mark.svg': new URL('@/assets/img/balm-pictorial-mark.svg', import.meta.url).href,
'book-open.svg': new URL('@/assets/img/book-open.svg', import.meta.url).href,
'bookmark-solana.svg': new URL('@/assets/img/bookmark-solana.svg', import.meta.url).href,
'bookmark.svg': new URL('@/assets/img/bookmark.svg', import.meta.url).href,
'calendar.svg': new URL('@/assets/img/calendar.svg', import.meta.url).href,
'chart-empty.svg': new URL('@/assets/img/chart-empty.svg', import.meta.url).href,
'check.svg': new URL('@/assets/img/check.svg', import.meta.url).href,
'chevron-down.svg': new URL('@/assets/img/chevron-down.svg', import.meta.url).href,
'chevron-left.svg': new URL('@/assets/img/chevron-left.svg', import.meta.url).href,
'corner-down-left.svg': new URL('@/assets/img/corner-down-left.svg', import.meta.url).href,
'current-plan-decoration.svg': new URL('@/assets/img/current-plan-decoration.svg', import.meta.url).href,
'cursor-box.svg': new URL('@/assets/img/cursor-box.svg', import.meta.url).href,
'download-01.svg': new URL('@/assets/img/download-01.svg', import.meta.url).href,
'expired-plan-decoration.svg': new URL('@/assets/img/expired-plan-decoration.svg', import.meta.url).href,
'favicon/balm.svg': new URL('@/assets/img/favicon/balm.svg', import.meta.url).href,
'file-plus-02.svg': new URL('@/assets/img/file-plus-02.svg', import.meta.url).href,
'file-shield.svg': new URL('@/assets/img/file-shield.svg', import.meta.url).href,
'filters-sliders.svg': new URL('@/assets/img/filters-sliders.svg', import.meta.url).href,
'flag-eu.svg': new URL('@/assets/img/flag-eu.svg', import.meta.url).href,
'flag-us.svg': new URL('@/assets/img/flag-us.svg', import.meta.url).href,
'google.svg': new URL('@/assets/img/google.svg', import.meta.url).href,
'hamburger-menu.svg': new URL('@/assets/img/hamburger-menu.svg', import.meta.url).href,
'hand.svg': new URL('@/assets/img/hand.svg', import.meta.url).href,
'high-five.svg': new URL('@/assets/img/high-five.svg', import.meta.url).href,
'layout-grid-01.svg': new URL('@/assets/img/layout-grid-01.svg', import.meta.url).href,
'list.svg': new URL('@/assets/img/list.svg', import.meta.url).href,
'lock.svg': new URL('@/assets/img/lock.svg', import.meta.url).href,
'log-out.svg': new URL('@/assets/img/log-out.svg', import.meta.url).href,
'media-backward.svg': new URL('@/assets/img/media-backward.svg', import.meta.url).href,
'media-expand.svg': new URL('@/assets/img/media-expand.svg', import.meta.url).href,
'media-forward.svg': new URL('@/assets/img/media-forward.svg', import.meta.url).href,
'media-maximize.svg': new URL('@/assets/img/media-maximize.svg', import.meta.url).href,
'media-pause.svg': new URL('@/assets/img/media-pause.svg', import.meta.url).href,
'media-play.svg': new URL('@/assets/img/media-play.svg', import.meta.url).href,
'message-chat-square.svg': new URL('@/assets/img/message-chat-square.svg', import.meta.url).href,
'mood_good.svg': new URL('@/assets/img/mood_good.svg', import.meta.url).href,
'mood_great.svg': new URL('@/assets/img/mood_great.svg', import.meta.url).href,
'mood_low.svg': new URL('@/assets/img/mood_low.svg', import.meta.url).href,
'mood_ok.svg': new URL('@/assets/img/mood_ok.svg', import.meta.url).href,
'mood_very_low.svg': new URL('@/assets/img/mood_very_low.svg', import.meta.url).href,
'partner-logo-allianz.svg': new URL('@/assets/img/partner-logo-allianz.svg', import.meta.url).href,
'partner-logo-usc.svg': new URL('@/assets/img/partner-logo-usc.svg', import.meta.url).href,
'payment-sun.svg': new URL('@/assets/img/payment-sun.svg', import.meta.url).href,
'payment-thumbs-up.svg': new URL('@/assets/img/payment-thumbs-up.svg', import.meta.url).href,
'percentage.svg': new URL('@/assets/img/percentage.svg', import.meta.url).href,
'plan-annual.svg': new URL('@/assets/img/plan-annual.svg', import.meta.url).href,
'plan-sun.svg': new URL('@/assets/img/plan-sun.svg', import.meta.url).href,
'play-icon-light.svg': new URL('@/assets/img/play-icon-light.svg', import.meta.url).href,
'play.svg': new URL('@/assets/img/play.svg', import.meta.url).href,
'plus.svg': new URL('@/assets/img/plus.svg', import.meta.url).href,
'portrait2.svg': new URL('@/assets/img/portrait2.svg', import.meta.url).href,
'right-down-arrow.svg': new URL('@/assets/img/right-down-arrow.svg', import.meta.url).href,
'shevron.svg': new URL('@/assets/img/shevron.svg', import.meta.url).href,
'shield.svg': new URL('@/assets/img/shield.svg', import.meta.url).href,
'sign-up/check-circle.svg': new URL('@/assets/img/sign-up/check-circle.svg', import.meta.url).href,
'sign-up/consents.svg': new URL('@/assets/img/sign-up/consents.svg', import.meta.url).href,
'sign-up/send.svg': new URL('@/assets/img/sign-up/send.svg', import.meta.url).href,
'sign-up/user-data.svg': new URL('@/assets/img/sign-up/user-data.svg', import.meta.url).href,
'sign-up/voucher.svg': new URL('@/assets/img/sign-up/voucher.svg', import.meta.url).href,
'sign-up/welcome.svg': new URL('@/assets/img/sign-up/welcome.svg', import.meta.url).href,
'star.svg': new URL('@/assets/img/star.svg', import.meta.url).href,
'thumb-up.svg': new URL('@/assets/img/thumb-up.svg', import.meta.url).href,
'thumbs-down.svg': new URL('@/assets/img/thumbs-down.svg', import.meta.url).href,
'thumbs-up.svg': new URL('@/assets/img/thumbs-up.svg', import.meta.url).href,
'today-all-caught-up.svg': new URL('@/assets/img/today-all-caught-up.svg', import.meta.url).href,
'today-tasks-ribbon.svg': new URL('@/assets/img/today-tasks-ribbon.svg', import.meta.url).href,
'topic-mental-wellbeing.svg': new URL('@/assets/img/topic-mental-wellbeing.svg', import.meta.url).href,
'topic-nutrition.svg': new URL('@/assets/img/topic-nutrition.svg', import.meta.url).href,
'topic-onboarding.svg': new URL('@/assets/img/topic-onboarding.svg', import.meta.url).href,
'topic-physical-activity.svg': new URL('@/assets/img/topic-physical-activity.svg', import.meta.url).href,
'topic-sleep.svg': new URL('@/assets/img/topic-sleep.svg', import.meta.url).href,
'trash.svg': new URL('@/assets/img/trash.svg', import.meta.url).href,
'user-profile.svg': new URL('@/assets/img/user-profile.svg', import.meta.url).href,
'volume-max.svg': new URL('@/assets/img/volume-max.svg', import.meta.url).href,
'volume-x.svg': new URL('@/assets/img/volume-x.svg', import.meta.url).href,
'x-close.svg': new URL('@/assets/img/x-close.svg', import.meta.url).href,
};
const logger = useLogger();

const data = ref<string | null>(null);
const loading = ref(false);
const error = ref<unknown>(null);

async function loadIcon(name: string): Promise<void> {
  loading.value = true;
  error.value = null;
  try {
    if (cache.has(name)) {
      logger.trace(`Returning ${name} from cache`)();
      data.value = await cache.get(name)!;
      return;
    }
    logger.debug(`Fetching ${name} icon`)();
    cache.set(name, (async(): Promise<string> => {
      if (!icons[name]) {
        logger.warn(`Icon "${name}" not found in build`)();
        return '';
      }
      const result = await fetch(icons[name]);
      return result.text();
    })());
    logger.debug(`Putting ${name} to cache`)();
    data.value = await cache.get(name)!;
  } catch (err) {
    error.value = err;
  } finally {
    loading.value = false;
  }
}

watch(() => props.name, (name) => {
  void loadIcon(name);
}, {immediate: true});

// SMIL animations (<animate> inside the SVG) are invisible to CSS, so a stylesheet's
// prefers-reduced-motion guard structurally cannot stop them. The DOM API can: pausing the
// timeline freezes every SMIL animation in the fragment. Re-applied after each load, since
// v-html replaces the <svg> element and a new timeline starts running.
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const wrapper = ref<HTMLElement | null>(null);

// Far past any entry animation. Pausing at t≈0 would remove content, not motion: entry
// animations draw a piece IN from an empty static state (stroke-dashoffset, opacity 0) and
// freeze at their end, so a frame-0 pause shows the unfinished drawing. Jumping the timeline
// first lands every fill="freeze" animation on its final frame and every periodic one on an
// arbitrary — but static — frame, which is what reduced motion should show: the finished
// artwork, not the show.
const PAST_ALL_ENTRY_ANIMATIONS_S = 60;

function syncSmilToMotionPreference(): void {
  const svg = wrapper.value?.querySelector('svg');
  if (!svg) {
    return;
  }
  if (reducedMotion.matches) {
    svg.setCurrentTime(PAST_ALL_ENTRY_ANIMATIONS_S);
    svg.pauseAnimations();
  } else {
    svg.unpauseAnimations();
  }
}

// All three, not just `data`: the element is gated on `!loading && !error` too, so a failed fetch
// unmounts it while `data` keeps the previous markup. Coming back to that same name is a cache hit
// that assigns the identical string, which would not wake a `data`-only watcher, and the element
// would remount with a running timeline under reduced motion.
watch([data, loading, error], () => {
  void nextTick(syncSmilToMotionPreference);
});
// The same MediaQueryList must be listened on and cleaned up: a listener-bearing MQL is
// retained by the platform to dispatch to, so an unremoved handler would keep this component's
// detached subtree alive once per mount (same pattern as journal-card-stack.vue).
reducedMotion.addEventListener('change', syncSmilToMotionPreference);
onUnmounted(() => {
  reducedMotion.removeEventListener('change', syncSmilToMotionPreference);
});
</script>
<template>
  <!-- eslint-disable vue/no-v-html -- bundled build-time SVG assets, not remote
       content; v-safe-html's HTML profile would strip the SVG markup -->
  <div
    v-if="!loading && !error"
    ref="wrapper"
    aria-hidden="true"
    class="svg-wrapper"
    :class="innerClass"
    v-html="data"
  />
  <!-- eslint-enable vue/no-v-html -->
</template>

<style lang="scss" scoped>
.svg-wrapper :deep(svg) {
  // by default inline which added px during line-height
  display: block;
  max-width: 100%;
  max-height: 100%;

  .current-color-f5b731 {
    color: #f5b731;
  }
  .current-color-f2e5d1 {
    color: #f2e5d1;
  }
  .current-color-f5f3f1 {
    color: #f5f3f1;
  }
  .current-color-dceadf {
    color: #dceadf;
  }
  .current-color-ffa595 {
    color: #ffa595;
  }
  .current-color-486a6e {
    color: #486a6e;
  }
  .current-color-2d5257 {
    color: #2d5257;
  }
  .current-color-454138 {
    color: #454138;
  }
  .current-color-f8725a {
    color: #f8725a;
  }
  .current-color-2e3343 {
    color: #2e3343;
  }
  .current-color-fa806b {
    color: #fa806b;
  }
  .current-color-d4d9da {
    color: #d4d9da;
  }
  .current-color-f1e4d0 {
    color: #f1e4d0;
  }
  .current-color-393c4b {
    color: #393c4b;
  }
  .current-color-ede1cf {
    color: #ede1cf;
  }
  .current-color-3a3d48 {
    color: #3a3d48;
  }
  .current-color-d3d8d9 {
    color: #d3d8d9;
  }
  .current-color-343948 {
    color: #343948;
  }
  .current-color-b0b5b8 {
    color: #b0b5b8;
  }
  .current-color-48696d {
    color: #48696d;
  }
  .current-color-434755 {
    color: #434755;
  }
  .current-color-f5735b {
    color: #f5735b;
  }
  .current-color-f1c158 {
    color: #f1c158;
  }
  .current-color-c1c6c7 {
    color: #c1c6c7;
  }
  .current-color-e9bb59 {
    color: #e9bb59;
  }
  .current-color-fea494 {
    color: #fea494;
  }
  .current-color-f5715a {
    color: #f5715a;
  }
  .current-color-f6715a {
    color: #f6715a;
  }
  .current-color-fda494 {
    color: #fda494;
  }
  .current-color-efe3cf {
    color: #efe3cf;
  }
  .current-color-f2f0ee {
    color: #f2f0ee;
  }
  .current-color-f3f1ef {
    color: #f3f1ef;
  }
  .current-color-d3d5d6 {
    color: #d3d5d6;
  }
  .current-color-f2715b {
    color: #f2715b;
  }
  .current-color-f1eeeb {
    color: #f1eeeb;
  }
  .current-color-ee735d {
    color: #ee735d;
  }
  .current-color-eae8e7 {
    color: #eae8e7;
  }
  .current-color-f3efe9 {
    color: #f3efe9;
  }
  .current-color-3d3946 {
    color: #3d3946;
  }
  .current-color-c2bfbc {
    color: #c2bfbc;
  }
  .current-color-e0ddd9 {
    color: #e0ddd9;
  }
  .current-color-bfd0c3 {
    color: #bfd0c3;
  }
  .current-color-385052 {
    color: #385052;
  }
  .current-color-f2e4d0 {
    color: #f2e4d0;
  }
  .current-color-dce8de {
    color: #dce8de;
  }
  .current-color-f5f2f0 {
    color: #f5f2f0;
  }
  .current-color-f2c159 {
    color: #f2c159;
  }
  .current-color-91949a {
    color: #91949a;
  }
  .current-color-f7a99b {
    color: #f7a99b;
  }
  .current-color-fff0d5 {
    color: #fff0d5;
  }
  .current-color-dceade {
    color: #dceade;
  }
  .current-color-fdfefe {
    color: #fdfefe;
  }
  .current-color-f18976 {
    color: #f18976;
  }
  .current-color-334e52 {
    color: #334e52;
  }
  .current-color-ebebeb {
    color: #ebebeb;
  }
  .current-color-383b45 {
    color: #383b45;
  }
  .current-color-ff6a4f {
    color: #ff6a4f;
  }
  .current-color-ffd2ca {
    color: #ffd2ca;
  }
  .current-color-f3c259 {
    color: #f3c259;
  }
  .current-color-334041 {
    color: #334041;
  }
  .current-color-abb6ad {
    color: #abb6ad;
  }
  .current-color-e4cba4 {
    color: #e4cba4;
  }
  .current-color-f2e9e3 {
    color: #f2e9e3;
  }
  .current-color-36595d {
    color: #36595d;
  }
}
</style>
